import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Perfil, PerfilEnum, PerfilElement, FiltroPerfil } from '@core/models/perfil.models';
import { AuthenticationService } from '@core/auth/authentication.service';
import { EmpresaEnum } from '@core/models/empresa.models';
import { MatPageable } from '@core/table/mat-table';
import { ApiService } from './api.service';

const routes = {
  buscaTodos: `perfil/buscatodos`,
  buscarTodos: (pagina: number, registros: number) => `perfil/buscatodos/${pagina}/${registros}`,
  buscarPorId: (id: string) => `perfil/buscaporid/${id}`,
  filtrarPerfil: `perfil/buscapornome`,
  inativar: `perfil/inativar`,
  reativar: `perfil/reativar`,
  cadastrar: `perfil/cadastrar`,
  alterar: `perfil/alterar`,
}

const perfis: Perfil[] = [
  { id: '1', nome: 'Administrador', idValue: 1 },
  { id: '2', nome: 'Super Usuário', idValue: 2 },
  { id: '3', nome: 'Usuário', idValue: 3 },
  { id: '4', nome: 'Master', idValue: 4 },
  { id: '5', nome: 'API', idValue: 5 },
  { id: '7', nome: 'Desenvolvedor', idValue: 7 }
]

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  constructor(private authenticantionService: AuthenticationService,
    private apiService: ApiService
  ) { }


  buscaTodos() {

    let filter = perfis;

    if (this.authenticantionService.currentUserValue.id_empresa != EmpresaEnum.CNSeg)
      filter = filter.filter(x => x.id == PerfilEnum.Master || x.id == PerfilEnum.Usuario)

    if (this.authenticantionService.currentUserValue.id_perfil.toString() == PerfilEnum.Master)
      filter = filter.filter(x => x.id == PerfilEnum.Master || x.id == PerfilEnum.Usuario)

    if (this.authenticantionService.currentUserValue.id_perfil.toString() == PerfilEnum.Usuario)
      filter = filter.filter(x => x.id == PerfilEnum.Usuario)


    return of(filter);
  }

  buscarTodos(pagination: MatPageable): Observable<Perfil[]> {
    return this.apiService.get<Perfil[]>(routes.buscarTodos(pagination.pagina, pagination.registros));
  }

  buscaTodosSemFiltroPerfil() {
    return of(perfis);
  }

  filtrarPerfil(pagination: MatPageable, filtro: FiltroPerfil): Observable<PerfilElement[]> {
    const params = this.apiService.convertObjectToParams(filtro);
    return this.apiService.get<PerfilElement[]>(routes.filtrarPerfil + pagination.query, params);
  }

  getPerfis(pagination: MatPageable, filtro: FiltroPerfil): Observable<PerfilElement[]> {
    return this.filtrarPerfil(pagination, filtro);
  }

  inativarPerfil(id: string): Observable<any> {
    return this.apiService.put<any>(routes.inativar, {
      Perfil: {
        idPerfil: id
      }
    });
  }

  reativarPerfil(id: string): Observable<any> {
    return this.apiService.put<any>(routes.reativar, {
      Perfil: {
        idPerfil: id
      }
    });
  }

  buscarPorId(id: string): Observable<PerfilElement> {
    return this.apiService.get<PerfilElement>(routes.buscarPorId(id));
  }

  getPerfilById(id: string): Observable<PerfilElement> {
    return this.buscarPorId(id);
  }

  criarPerfil(perfil: PerfilElement): Observable<any> {
    return this.apiService.post<any>(routes.cadastrar, {
      Perfil: {
        nome: perfil.nome,
        ativo: perfil.ativo
      }
    });
  }

  editarPerfil(perfil: PerfilElement): Observable<any> {
    return this.apiService.put<any>(routes.alterar, {
      Perfil: {
        idPerfil: Number(perfil.id),
        nome: perfil.nome
      }
    });
  }
}
